import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';
import { format } from 'date-fns';

const formatDateCell = (value: unknown) =>
  value ? format(new Date(value as string | number | Date), 'dd/MM/yyyy') : '';

export const getDataTableColumns = (handleViewClick: () => void, status?: string): DataTableColumn[] => {
  const columns: DataTableColumn[] = [
    {
      field: 'so_ct',
      headerName: 'Số đơn từ',
      width: 150,
      renderCell: params => (
        <button onClick={handleViewClick} className='hover:text-blue-500 hover:underline'>
          {params.row.so_ct}
        </button>
      )
    },
    {
      field: 'ngay_ct',
      headerName: 'Ngày',
      width: 120,
      renderCell: params => formatDateCell(params.value)
    },
    {
      field: 'ma_nvbh',
      headerName: 'Nhân viên',
      width: 150,
      renderCell: params => params.row.ma_kh_data?.sales_rep_data?.ho_ten_nhan_vien || ''
    },
    {
      field: 'dien_giai',
      headerName: 'Phân loại và diễn giải',
      width: 250,
      renderCell: params => `Phiếu yêu cầu duyệt đơn hàng (${params.row.dien_giai})`
    },
    {
      field: 'status',
      headerName: 'Trạng thái',
      width: 150,
      renderCell: params => {
        const status = params.value;
        switch (status) {
          case '0':
            return 'Nháp';
          case '1':
            return 'Chờ duyệt';
          case '5':
            return 'Hoàn thành';
          case '9':
            return 'Đóng';
          default:
            return status;
        }
      }
    },
    { field: 'cap_duyet', headerName: 'Cấp duyệt', width: 100 },
    {
      field: 't_tt',
      headerName: 'Tiền',
      width: 150,
      type: 'number',
      renderCell: params => (params.value ? Number(params.value).toLocaleString('vi-VN') : '0')
    },
    { field: 'cho_duyet_tiep', headerName: 'Chờ duyệt tiếp', width: 100 },
    { field: 'cho_duyet', headerName: 'Chờ duyệt', width: 100 },
    { field: 'da_duyet', headerName: 'Đã duyệt', width: 100 },
    {
      field: 'ngay_duyet_gan_nhat',
      headerName: 'Duyệt gần nhất',
      width: 120,
      renderCell: params => formatDateCell(params.value)
    },
    {
      field: 'ngay_hl',
      headerName: 'Ngày hoàn thành',
      width: 120,
      renderCell: params => formatDateCell(params.value)
    },
    {
      field: 'unit_id',
      headerName: 'Đơn vị',
      width: 150,
      renderCell: params => params.row.unit_id_data?.ten_unit || ''
    },
    {
      field: 'created',
      headerName: 'Ngày tạo',
      width: 120,
      renderCell: params => formatDateCell(params.value)
    },
    { field: 'phan_loai', headerName: 'Phân loại', width: 150 }
  ];

  status === '-3' && columns.unshift({ field: 'checkbox', headerName: '', width: 50 });

  return columns;
};

export const getInputTableColumns = (): DataTableColumn[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã ku',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.ma_vt
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => params.row.ma_vt_data?.ten_vt
  },
  {
    field: 'dvt',
    headerName: 'Đvt',
    width: 100,
    renderCell: params => params.row.dvt_data?.dvt
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => params.row.ma_kho_data?.ma_kho
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100
  },
  {
    field: 'ct_km',
    headerName: 'Loại hàng',
    width: 120,
    renderCell: params => {
      const ctKm = params.row.ct_km;
      switch (ctKm) {
        case false:
          return 'Hàng bán';
        case true:
          return 'Hàng KM';
      }
    }
  },
  {
    field: 'ma_loai_gb',
    headerName: 'Loại giá',
    width: 150
  },
  {
    field: 'gia_nt1',
    headerName: 'Giá chuẩn %',
    width: 150
  },
  {
    field: 'gia_nt2',
    headerName: 'Giá bán %',
    width: 150
  },
  {
    field: 'tien_nt2',
    headerName: 'Thành tiền %',
    width: 150
  },
  {
    field: 'ngay_giao',
    headerName: 'Ngày giao',
    width: 150
  },
  {
    field: 'tl_ck',
    headerName: 'Tl ck(%)',
    width: 150
  },
  {
    field: 'ck_nt',
    headerName: 'Ch.khấu %s',
    width: 150
  },
  {
    field: 'ma_thue',
    headerName: 'Thuế suất',
    width: 100
  },
  {
    field: 'thue_nt',
    headerName: 'Thuế %',
    width: 100
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => params.row.ma_bp_data?.ma_bp
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_sp_data?.ma_vt
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 120
  },
  {
    field: 'gia1',
    headerName: 'Giá chuẩn',
    width: 120
  },
  {
    field: 'gia2',
    headerName: 'Giá bán',
    width: 120
  },
  {
    field: 'tien2',
    headerName: 'Thành tiền',
    width: 120
  },
  {
    field: 'ck',
    headerName: 'Chiết khấu',
    width: 120
  },
  {
    field: 'thue',
    headerName: 'Thuế',
    width: 120
  },
  {
    field: 'sl_don_hang',
    headerName: 'Sl đơn hàng',
    width: 120
  },
  {
    field: 'sl_hd',
    headerName: 'Sl hoá đơn',
    width: 120
  },
  {
    field: 'sl_px',
    headerName: 'Sl xuất',
    width: 120
  },
  {
    field: 'so_ct_hd',
    headerName: 'Số hợp đồng',
    width: 120
  },
  {
    field: 'line_hd',
    headerName: 'Dòng HĐ',
    width: 120
  },
  {
    field: 'so_ct_bg',
    headerName: 'Số báo giá',
    width: 120
  },
  {
    field: 'line_bg',
    headerName: 'Dòng BG',
    width: 120
  }
];
